<ng-container *ngIf="employment">
  <div>
    {{
      employment.canceledAt
        ? (("canceledAt" | i18n) || "Storniert am") +
          " " +
          (employment.canceledAt | date: "short")
        : ("canceled" | i18n) || "Storniert"
    }}
    <div *ngIf="employment.cancelReason">
      {{
        (("cancelReason" | i18n) || "Storniergrund:") +
          " " +
          employment.cancelReason.displayName[lang] +
          (employment.cancelReasonDescription
            ? "\n" + employment.cancelReasonDescription
            : "")
      }}
    </div>
    <div *ngIf="cancelUser">
      {{
        (("canceledBy" | i18n) || "Storniert von") +
          " " +
          cancelUser.firstName +
          " " +
          cancelUser.lastName
      }}
    </div>
  </div>
</ng-container>
